import React, { useState, useEffect, useCallback } from 'react';
import TinyEditor from './TinyEditor';
import { bbcodeToHtml, containsBBCode } from '../../../utils/bbcode.utils';
import { convertCommentIfNeeded } from '../../../scripts/convertComment';

const BBCodeEditor = ({ initialValue = '', onSave, ...props }) => {
    const [originalValue, setOriginalValue] = useState('');
    const [convertedValue, setConvertedValue] = useState(null);
    const [isProcessed, setIsProcessed] = useState(false);

    // Traiter le contenu initial (uniquement si BBCode)
    useEffect(() => {
        console.log('initialValue', initialValue);
        if (initialValue && initialValue !== '') {
            // Sauvegarder l'original
            setOriginalValue(initialValue);

            // Prétraiter pour détecter le BBCode correctement même avec \n littéraux
            const preprocessedValue = initialValue.replace(/\\n/g, '\n');
            const hasBBCode = containsBBCode(preprocessedValue);

            if (hasBBCode) {
                // Convertir le BBCode en HTML seulement si BBCode détecté
                const converted = convertCommentIfNeeded(initialValue);
                setConvertedValue(converted);
            } else {
                // Aucune conversion si pas de BBCode
                setConvertedValue(preprocessedValue);
            }

            setIsProcessed(true);
        }
    }, [initialValue]);

    // Fonction de sauvegarde qui gère la conversion si nécessaire
    const handleSave = useCallback(async (value) => {
        try {
            // Sauvegarder le contenu déjà au format HTML
            await onSave(value);
            return value;
        } catch (error) {
            console.error('Erreur lors de la sauvegarde:', error);
            throw error;
        }
    }, [onSave]);

    // Afficher un indicateur de chargement en attendant la conversion
    if (initialValue && !isProcessed) {
        return <div className="p-2 text-gray-600">Préparation de l'éditeur...</div>;
    }

    return (

        <TinyEditor
            initialValue={convertedValue}
            onSave={handleSave}
            {...props}
        />
    );
};

export default BBCodeEditor;
